import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Product } from '@scalefast/core';
import { CleanTextHelper } from '../../../shared/helpers/clean-text.helper';
import { TranslateProductFieldPipe } from '../../pipes/translate-product-field.pipe';

@Component({
  standalone: true,
  selector: 'app-schema-structured-data',
  template: '<div [innerHTML]="html"></div>',
  styles: [],
  providers: [TranslateProductFieldPipe],
})
export class AppSchemaStructuredDataComponent implements OnInit {
  @Input() product: Product | undefined;

  itemLD: any;
  html: SafeHtml;

  constructor(
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private sanitizer: DomSanitizer,
    private translatePipe: TranslateProductFieldPipe,
  ) {
    this.html = '';
    this.itemLD = {};
  }

  ngOnInit() {
    this.getProductInfo();
    this.html = this.getSafeHTML(this.itemLD);
  }

  getSafeHTML(jsonLD: { [key: string]: any }): SafeHtml {
    const json = jsonLD ? JSON.stringify(jsonLD, null, 2).replace(/<\/script>/g, '<\\/script>') : '';
    // escape / to prevent script tag in JSON
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getProductInfo() {
    let images = this.product?.gallery.map(function (item) {
      return item.url;
    });

    let availability = 'OutOfStock';
    if (typeof this.product?.stock?.stock !== 'undefined' && this.product?.stock.stock > 0) {
      availability = 'InStock';
    }

    let description = '';
    description =
      (this.product ? this.translatePipe.transform(this.product, 'short') : '') +
      '. ' +
      (this.product ? this.translatePipe.transform(this.product, 'long') : '');

    let url = '';
    if (isPlatformBrowser(this.platformId)) {
      url = location.protocol + '//' + location.host + location.pathname; //this information is not available in the source code
    }

    let productID = this.product?.v4ApiResponse?.ean ? 'ean:' + this.product.v4ApiResponse.ean : '';

    this.itemLD = {
      '@context': 'http://schema.org/',
      '@type': 'Product',
      '@id': url,
      name: this.product ? this.translatePipe.transform(this.product, 'title') : undefined,
      image: images,
      description: CleanTextHelper.removeHtml(description, this._doc).substring(0, 317) + '...',
      sku: this.product?.refID,
      productID: productID,
      brand: {
        '@type': 'Thing',
        name: 'Oral-B',
      },
      offers: [
        {
          '@type': 'Offer',
          availability: availability,
          priceCurrency: this.product?.price?.currency,
          itemCondition: 'https://schema.org/NewCondition',
          price: this.product?.price?.prices[0].price,
          sku: this.product?.refID,
        },
      ],
    };
  }
}
